<div class="flex justify-center items-start min-h-screen p-3xl bg-page-backgrounds-light">
  @if (loading()) {
    <div class="flex flex-col items-center justify-center min-h-[50vh]">
      <db-progress-spinner />
      <p class="mt-2xl typography-body !text-text-secondary">Loading your visit information...</p>
    </div>
  } @else if (visit()) {
    <div class="bg-containers-light rounded-lg shadow-small max-w-[480px] w-full overflow-hidden">
      <header class="p-2xl flex justify-center border-b border-borders-lighter">
        @if (visit()?.company?.logo) {
          <img
            [src]="visit()?.company?.logo"
            [alt]="visit()?.company?.name"
            class="max-h-5xl max-w-[200px] object-contain"
          />
        }
      </header>

      <section class="px-3xl py-2xl text-center border-b border-borders-lighter">
        <h1 class="typography-heading-3 mb-lg">
          Hi {{ getVisitorDisplayName() }}, welcome to {{ visit()?.company?.name }}!
        </h1>
        <p class="typography-body !text-text-secondary">
          Your visit is on
          {{ visit()?.startDateTime | date: "EEEE, dd MMMM yyyy" }}
        </p>
      </section>

      <section class="p-2xl text-center bg-page-backgrounds-light border-b border-borders-lighter">
        <h2 class="typography-heading-4 !text-text-secondary mb-xl">Your visitor code</h2>
        <div class="flex justify-center gap-lg mb-lg">
          @for (char of visit()?.visitor?.code?.split("") ?? []; track $index) {
            <span
              class="typography-heading-2 bg-page-backgrounds-darker w-5xl h-5xl flex items-center justify-center rounded-md"
            >
              {{ char }}
            </span>
          }
        </div>
        <p class="typography-body !text-text-inactive max-w-[280px] mx-auto">
          Use the code to identify yourself in reception or checking-in at the kiosk.
        </p>
      </section>

      <section class="px-3xl pt-2xl pb-3xl border-b border-borders-lighter">
        <h2 class="typography-heading-4 !text-text-secondary mb-2xl">Visit details</h2>
        <div class="flex items-center gap-xl mb-2xl pb-2xl border-b border-borders-lighter">
          <db-user-avatar
            [userInfo]="organizerUserView()"
            avatarSize="standard"
            [showTooltips]="false"
          />
          <div class="flex flex-col">
            <span class="typography-body-bold">
              {{ getOrganizerDisplayName() }}
            </span>
            <span class="typography-small !text-text-secondary">
              {{ visit()?.organizer?.email }}
            </span>
          </div>
        </div>

        <div class="flex flex-col gap-xl">
          <div class="flex items-center gap-xl typography-body">
            <span class="w-3xl text-center">📅</span>
            <span>{{ visit()?.startDateTime | date: "EEEE, dd MMMM yyyy" }}</span>
          </div>
          <div class="flex items-center gap-xl typography-body">
            <span class="w-3xl text-center">🕚</span>
            <span>
              {{ visit()?.startDateTime | date: "HH:mm" }} -
              {{ visit()?.endDateTime | date: "HH:mm" }}
            </span>
          </div>
          <div class="flex items-center gap-xl typography-body">
            <span class="w-3xl text-center">🏢</span>
            <span>
              {{ visit()?.location?.officeName }}
              @if (visit()?.location?.officeAddress) {
                , {{ getFormattedAddress() }}
              }
            </span>
          </div>
          <div class="flex items-center gap-xl typography-body">
            <span class="w-3xl text-center">👤</span>
            <span>Organizer: {{ getOrganizerDisplayName() }}</span>
          </div>
        </div>
      </section>

      @if (visit()?.instructions) {
        <section class="p-3xl">
          <h2 class="typography-heading-4 !text-text-secondary mb-xl">Instructions</h2>
          <p class="typography-body whitespace-pre-wrap">
            {{ visit()?.instructions }}
          </p>
        </section>
      }
    </div>
  }
</div>
